import es from 'vee-validate/dist/locale/es.json';

export default {
  validation: es.messages,
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/vee-validate.js